package com.nonopn.skydome.common.app.pages.probes

import com.nonopn.skydome.common.app.api.impl.AccountStatus
import com.nonopn.skydome.common.app.api.impl.ProbeApp
import com.nonopn.skydome.common.app.home.AppModel
import kotlinx.coroutines.CancellationException

/**
 * Loads GET /api/account/status for Strike Radar, with the same authenticated client as the checkout routes.
 * Returns null when the route is not reachable or fails (old server, network): the callers then keep
 * their previous behaviour (probes of the dashboard reports, buttons not restricted).
 */
suspend fun AppModel.loadAccountStatus(): AccountStatus? {
    val providers = states.value.apiProvider
    val api = providers?.apiNormal ?: providers?.apiAdmin ?: return null
    return try {
        api.accountStatus(ProbeApp.STRIKE_RADAR)
    } catch (e: CancellationException) {
        throw e
    } catch (_: Throwable) {
        null
    }
}
